<img
  src="../../../../assets/icons/add-area.svg"
  alt="no icon"
  class="icon"
  [ngClass]="{ disabled: !canUpdate }"
  (click)="addArea()"
/>
